import { render, staticRenderFns } from "./IconMaterials.vue?vue&type=template&id=919a4808&functional=true"
import script from "./IconMaterials.vue?vue&type=script&lang=js"
export * from "./IconMaterials.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  true,
  null,
  null,
  null
  
)

export default component.exports